<template>
	<div></div>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ActionPdfUtils } from "../../../utils/ActionPdf.utils"; 
import nymbleUpLogo from "../../../assets/images/logo/NymbleUp - N.jpg";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { EventBus } from "../../../eventBus";

var moment = require("moment");
export default {
	props: {
		data: Array,
		meta: Object,
	},
	data() {
		return {
			title: "My Title",
			content: "Some text content here.",
			imageUrl: nymbleUpLogo,
			moment: moment,
		};
	},
	mounted() {
		EventBus.$on("loadActionPdfFirst", () => {
			this.exportAsPDF();
		});
	},
	methods: {
		async exportAsPDF() {
			try {
				let img =
					this.meta && this.meta.company_meta
						? this.meta.company_meta.logo_url
						: this.imageUrl;
				const imageBase64 = await this.imageUrlToBase64(img);
				if (!imageBase64) {
					throw new Error("Failed to load image.");
				}
				const headerSection = this.createHeaderSection(imageBase64);
				const contentRows = await this.createContentRows(this.data);
				const documentDefinition = {
					content: [headerSection, ...contentRows],
					styles: ActionPdfUtils, 
					pageOrientation: "portrait",
					pageSize: "A4",
					pageMargins: [40, 15, 40, 15],
				};

				const pdfDoc = pdfMake.createPdf(documentDefinition);
				pdfDoc.download(
					`Action Plan - ${this.meta.location}_${this.meta.project}`
				);
				this.$nextTick(() => {
					setTimeout(() => {
						EventBus.$emit("pdf-downloaded-successfully");
					}, 100);
				});
			} catch (error) {
				console.error("Error exporting PDF:", error);
			}
		},
		createHeaderSection(imageBase64) {
			return [
				{
					text: `Action Plan - ${this.meta.project}`,
					fontSize: 16,
					bold: true,
					alignment: "center",
					margin: [0, 0, 0, 10],
				},
				{
					columns: [
						{
							image: imageBase64,
							width: 70,
							margin: [-20, -20, 0, 0],
							alignment: "left",
						},
						{
							table: {
								widths: ["33%", "33%", "33%"],
								body: [
									[
										this.createHeaderCell("Location", this.meta.location),
										this.createHeaderCell("Auditor", this.meta.auditor),
										this.createHeaderCell("Region", this.meta.region),
									],
									[
										this.createHeaderCell("Approved By", this.meta.approved_by),
										this.createHeaderCell("Due Date", this.meta.due_date),
										this.createHeaderCell(
											"Submitted By",
											this.meta.submitted_by
										),
									],
									[
										this.createHeaderCell(
											"Submitted On",
											moment
												.utc(this.meta.approved_on)
												.local()
												.format("Do MMM YYYY, hh:mm A")
										),
										this.createHeaderCell(
											"Auto-Approved",
											this.meta.auto_approved == true ? "Yes" : "No"
										),
										this.createHeaderCell("", ""),
									],
								],
							},
							margin: [20, 0, 0, 0],
						},
					],
				},
			];
		},
		createHeaderCell(label, value) {
			if (!label) {
				return null;
			}
			return {
				text: [
					{ text: `${label}: `, style: "headText1" },
					{ text: this.capitalizeWords(value) || "-", style: "headText2" },
				],
			};
		},
		capitalizeWords(sentence) {
			if (!sentence || typeof sentence !== "string") {
				return "-";
			}
			return sentence.replace(/\b\w/g, (char) => char.toUpperCase());
		},
		async createContentRows(data) {
			const rows = [];
			rows.push({ text: "", margin: [0, 30, 0, 0] });
			let serialNumber = 1;
			for (const item of data) {
				const raisedAttachments = await this.getAttachmentsText(
					item.action_raised_attachments
				);
				const takenAttachments = await this.getAttachmentsText(
					item.action_taken_attachments
				);
				const content = this.createContent(
					item,
					raisedAttachments,
					takenAttachments,
					serialNumber
				);
				rows.push({
					table: {
						widths: ["*"],
						body: [[{ stack: content, fillColor: "#FFFFFF" }]],
					},
					layout: "noBorders",
				});
				rows.push({ text: "", margin: [0, 30, 0, 0] });
				serialNumber++;
			}
			return rows;
		},
		createContent(item, raisedAttachments, takenAttachments, serialNumber) {
			const style = { fontWeight: "bold", fontSize: 9 }; 
			const labelWidth = "20%";
			const createdOn = moment
				.utc(item.created_on)
				.local()
				.format("Do MMM YYYY, hh:mm A");
			const userComment = item.action_raised_comment || "-";
			const actionComment = item.action_taken_comment || "-";
			const numericValue = parseFloat(item.numeric_value) || 0;
			const serialAndStepTitleRow = {
				table: {
					widths: ["100%"],
					body: [
						[
							{
								text: `${serialNumber}. ${item.form_question}`,
								style: style,
								fillColor: "#FFFFFF",
							},
						],
					],
				},
				layout: "noBorders",
			};

			return [
				serialAndStepTitleRow,
				{
					canvas: [
						{ type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 },
					],
				}, 
				this.createRowWithWidth("Created On", createdOn, style, labelWidth),
				this.createRowWithWidth(
					"Category Title",
					item.form_category,
					style,
					labelWidth
				),
				this.createRowWithWidth("Form Title", item.form, style, labelWidth),
				this.createRowWithWidth(
					"User Input",
					item.user_input,
					style,
					labelWidth
				),
				this.createRowWithWidth("Comment", userComment, style, labelWidth),
				this.createAttachmentSection(
					"Attachments",
					raisedAttachments,
					style,
					labelWidth
				),
				this.createRowWithWidth(
					"Action Taken",
					actionComment,
					style,
					labelWidth,
					"1"
				),
				this.createAttachmentSection(
					"Attachments",
					takenAttachments,
					style,
					labelWidth
				),
			];
		},
		async getAttachmentsText(attachments) {
			if (attachments.length > 0) {
				return await this.getAttachmentsWithCol(attachments);
			}
			return "-";
		},
		createRowWithWidth(label, value, style, labelWidth, type) {
			const labelStyle = { bold: true, fontSize: 9 }; 
			const valueStyle = { fontSize: 9 }; 
			return {
				columns: [
					{
						width: labelWidth,
						text: `${label}:`,
						style: style || "dataRow",
						...labelStyle,
						margin: [0, 0, 0, 0],
					},
					{ width: "80%", text: value, ...valueStyle, margin: [0, 0, 0, 0] }, 
				],
				margin: type == "1" ? [0, 30, 0, 0] : [0, 10, 0, 0],
			};
		},
		createAttachmentSection(label, attachments, style, labelWidth) {
			if (Array.isArray(attachments) && attachments.length > 0) {
				const attachmentSection = [
					{
						columns: [
							{
								width: labelWidth,
								text: `${label}:`,
								style: "dataRow",
								bold: true,
								fontSize: 9,
								margin: [0, 10, 0, 0],
							},
							{
								width: "*", 
								stack: attachments.map((group) => ({
									columns: group.columns.map((imageData) => ({
										image: imageData.image,
										width: imageData.width || 180,
										height: imageData.height || 150,
										alignment: imageData.alignment || "center",
										margin: imageData.margin || [0, 10, 0, 10],
									})),
									margin: group.margin || [20, 0],
								})),
							},
						],
						margin: [0, 10, 0, 0],
					},
				];
				return { stack: attachmentSection };
			}
			return {
				columns: [
					{
						width: labelWidth,
						text: `${label}:`,
						style: "dataRow",
						bold: true,
						fontSize: 9,
						margin: [0, 10, 0, 0],
					},
					{ width: "*", text: "-", margin: [0, 5, 0, 0], fontSize: 9 }, 
				],
				margin: [0, 10, 0, 0],
			};
		},
		createLine() {
			return {
				canvas: [{ type: "line", x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 1 }],
			};
		},
		createTextRow(label, value, margin = [0, 10, 0, 0]) {
			return {
				text: `${label}: ${value}`,
				style: "dataRow",
				margin: margin,
			};
		},
		async getAttachmentsWithCol(arr) {
			let result = [];

			for (let i = 0; i < arr.length; i += 2) {
				try {
					let imageUrl1 = arr[i];
					if (
						!imageUrl1.includes(
							"https://nymbleup-tasks-attachments.s3.amazonaws.com/"
						)
					) {
						imageUrl1 =
							"https://nymbleup-tasks-attachments.s3.amazonaws.com/" +
							imageUrl1;
					}
					const base64Image1 = await this.imageUrlToBase64(imageUrl1);
					let group = {
						columns: [
							{
								image: base64Image1,
								width: 180,
								height: 150,
								alignment: "center",
								margin: [0, 0, 15, 15],
							},
						],
						margin: [20, 0],
					};
					if (i + 1 < arr.length) {
						let imageUrl2 = arr[i + 1];
						if (
							!imageUrl2.includes(
								"https://nymbleup-tasks-attachments.s3.amazonaws.com/"
							)
						) {
							imageUrl2 =
								"https://nymbleup-tasks-attachments.s3.amazonaws.com/" +
								imageUrl2;
						}
						const base64Image2 = await this.imageUrlToBase64(imageUrl2);
						group.columns.push({
							image: base64Image2,
							width: 180,
							height: 150,
							alignment: "center",
							margin: [15, 0, 0, 15],
						});
					}
					result.push(group);
				} catch (error) {
					console.error("Error processing image:", error);
					result.push({
						text: "Error loading image",
						style: "dataRow",
						margin: [0, 5, 0, 0],
					});
				}
			}
			return result;
		},
		async imageUrlToBase64(imageUrl) {
			try {
				const response = await fetch(imageUrl);
				const blob = await response.blob();
				const base64Data = await new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = () => resolve(reader.result);
					reader.onerror = reject;
					reader.readAsDataURL(blob);
				});
				return base64Data;
			} catch (error) {
				console.error("Error converting image URL to base64:", error);
				return null;
			}
		},
	},
};
</script>

<style scoped></style>
